const AjaxRequest = (url, options = { method: 'POST', body: null }, successCallback = null, errorCallback = null) => {
  fetch(url, {
    method: options.method,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': document.head.querySelector("[name='csrf-token']").content,
      Authorization: `Bearer ${AD.getAccessToken()}`,
    },
    body: JSON.stringify(options.body),
  })
    .then((resp) => resp.json().then((data) => ({ status: resp.status, body: data })))
    .then((resp) => {
      if (resp.status >= 400) {
        if (errorCallback) errorCallback(resp);
      } else if (successCallback) successCallback(resp.body);
    })
    .catch((error) => {
      if (errorCallback) errorCallback(error);
    });
};

export default AjaxRequest;
